"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotAuthenticated = exports.isNotImplemented = exports.isNotSupported = exports.isUnexpectedError = exports.isUnexpectedResponseError = exports.isProtectedDataError = exports.isDataTooLargeError = exports.isNoDataError = exports.isAnalyticalBackendError = exports.NotAuthenticated = exports.NotImplemented = exports.NotSupported = exports.UnexpectedError = exports.UnexpectedResponseError = exports.ProtectedDataError = exports.DataTooLargeError = exports.NoDataError = exports.AnalyticalBackendError = exports.AnalyticalBackendErrorTypes = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Types of errors that can be raised by Analytical Backends.
 *
 * @public
 */
exports.AnalyticalBackendErrorTypes = {
    NO_DATA: "ND",
    DATA_TOO_LARGE: "DTL",
    PROTECTED_DATA: "PD",
    UNEXPECTED_HTTP: "UH",
    UNEXPECTED: "UE",
    NOT_SUPPORTED: "NS",
    NOT_IMPLEMENTED: "NI!",
    NOT_AUTHENTICATED: "NAuth",
};
/**
 * Superclass for all exceptions that can occur in Analytical Backend.
 *
 * @public
 */
var AnalyticalBackendError = /** @class */ (function (_super) {
    tslib_1.__extends(AnalyticalBackendError, _super);
    function AnalyticalBackendError(message, abeType, cause) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.abeType = abeType;
        _this.cause = cause;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return AnalyticalBackendError;
}(Error));
exports.AnalyticalBackendError = AnalyticalBackendError;
/**
 * This exception MUST be thrown when the backend execution identifies that there is no data to
 * calculate.
 *
 * @public
 */
var NoDataError = /** @class */ (function (_super) {
    tslib_1.__extends(NoDataError, _super);
    function NoDataError(message, dataView, cause) {
        var _this = _super.call(this, message, exports.AnalyticalBackendErrorTypes.NO_DATA, cause) || this;
        _this.dataView = dataView;
        return _this;
    }
    return NoDataError;
}(AnalyticalBackendError));
exports.NoDataError = NoDataError;
/**
 * This exception MUST be thrown when backend execution identifies that there is too much data
 * to process for the execution and refuses to proceed.
 *
 * @public
 */
var DataTooLargeError = /** @class */ (function (_super) {
    tslib_1.__extends(DataTooLargeError, _super);
    function DataTooLargeError(message, cause) {
        return _super.call(this, message, exports.AnalyticalBackendErrorTypes.DATA_TOO_LARGE, cause) || this;
    }
    return DataTooLargeError;
}(AnalyticalBackendError));
exports.DataTooLargeError = DataTooLargeError;
/**
 * This exception MUST be thrown when backend execution identifies that the data to calculate
 * results for is protected and the caller lacks the sufficient authorization.
 *
 * @public
 */
var ProtectedDataError = /** @class */ (function (_super) {
    tslib_1.__extends(ProtectedDataError, _super);
    function ProtectedDataError(message, cause) {
        return _super.call(this, message, exports.AnalyticalBackendErrorTypes.PROTECTED_DATA, cause) || this;
    }
    return ProtectedDataError;
}(AnalyticalBackendError));
exports.ProtectedDataError = ProtectedDataError;
/**
 * This exception MUST be thrown when communication with the backend encounters an unexpected
 * response status code and it cannot handle or categorize it to a known, domain-specific error.
 *
 * @public
 */
var UnexpectedResponseError = /** @class */ (function (_super) {
    tslib_1.__extends(UnexpectedResponseError, _super);
    function UnexpectedResponseError(message, httpStatus, responseBody, cause) {
        var _this = _super.call(this, message, exports.AnalyticalBackendErrorTypes.UNEXPECTED_HTTP, cause) || this;
        _this.httpStatus = httpStatus;
        _this.responseBody = responseBody;
        return _this;
    }
    return UnexpectedResponseError;
}(AnalyticalBackendError));
exports.UnexpectedResponseError = UnexpectedResponseError;
/**
 * This exception MUST be thrown when the unexpected happens. This is a last-resort error type that SHOULD
 * be used if the erroneous state cannot be categorized in a better way.
 *
 * @public
 */
var UnexpectedError = /** @class */ (function (_super) {
    tslib_1.__extends(UnexpectedError, _super);
    function UnexpectedError(message, cause) {
        return _super.call(this, message, exports.AnalyticalBackendErrorTypes.UNEXPECTED, cause) || this;
    }
    return UnexpectedError;
}(AnalyticalBackendError));
exports.UnexpectedError = UnexpectedError;
/**
 * This exception is thrown when client code asks Analytical Backend to exercise an unsupported feature.
 *
 * @public
 */
var NotSupported = /** @class */ (function (_super) {
    tslib_1.__extends(NotSupported, _super);
    function NotSupported(message) {
        return _super.call(this, message, exports.AnalyticalBackendErrorTypes.NOT_SUPPORTED) || this;
    }
    return NotSupported;
}(AnalyticalBackendError));
exports.NotSupported = NotSupported;
/**
 * This exception is thrown when client code asks Analytical Backend to exercise a feature that is not
 * implemented yet.
 * @public
 */
var NotImplemented = /** @class */ (function (_super) {
    tslib_1.__extends(NotImplemented, _super);
    function NotImplemented(message) {
        return _super.call(this, message, exports.AnalyticalBackendErrorTypes.NOT_IMPLEMENTED) || this;
    }
    return NotImplemented;
}(AnalyticalBackendError));
exports.NotImplemented = NotImplemented;
/**
 * This exception is thrown when client code triggers an operation which requires authentication but the client
 * code did not provide credentials or the credentials are invalid.
 *
 * @public
 */
var NotAuthenticated = /** @class */ (function (_super) {
    tslib_1.__extends(NotAuthenticated, _super);
    function NotAuthenticated(message, cause, reason) {
        var _this = _super.call(this, message, exports.AnalyticalBackendErrorTypes.NOT_AUTHENTICATED, cause) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAuthenticated;
}(AnalyticalBackendError));
exports.NotAuthenticated = NotAuthenticated;
/**
 * Type guard checking whether input is an instance of {@link AnalyticalBackendError}
 *
 * @public
 */
function isAnalyticalBackendError(obj) {
    return !isEmpty_1.default(obj) && obj.abeType !== undefined;
}
exports.isAnalyticalBackendError = isAnalyticalBackendError;
/**
 * Type guard checking whether input is an instance of {@link NoDataError}
 *
 * @public
 */
function isNoDataError(obj) {
    return isAnalyticalBackendError(obj) && obj.abeType === exports.AnalyticalBackendErrorTypes.NO_DATA;
}
exports.isNoDataError = isNoDataError;
/**
 * Type guard checking whether input is an instance of {@link DataTooLargeError}
 *
 * @public
 */
function isDataTooLargeError(obj) {
    return isAnalyticalBackendError(obj) && obj.abeType === exports.AnalyticalBackendErrorTypes.DATA_TOO_LARGE;
}
exports.isDataTooLargeError = isDataTooLargeError;
/**
 * Type guard checking whether input is an instance of {@link ProtectedDataError}
 *
 * @public
 */
function isProtectedDataError(obj) {
    return isAnalyticalBackendError(obj) && obj.abeType === exports.AnalyticalBackendErrorTypes.PROTECTED_DATA;
}
exports.isProtectedDataError = isProtectedDataError;
/**
 * Type guard checking whether input is an instance of {@link UnexpectedResponseError}
 *
 * @public
 */
function isUnexpectedResponseError(obj) {
    return isAnalyticalBackendError(obj) && obj.abeType === exports.AnalyticalBackendErrorTypes.UNEXPECTED_HTTP;
}
exports.isUnexpectedResponseError = isUnexpectedResponseError;
/**
 * Type guard checking whether input is an instance of {@link UnexpectedResponseError}
 *
 * @public
 */
function isUnexpectedError(obj) {
    return isAnalyticalBackendError(obj) && obj.abeType === exports.AnalyticalBackendErrorTypes.UNEXPECTED;
}
exports.isUnexpectedError = isUnexpectedError;
/**
 * Type guard checking whether input is an instance of {@link NotSupported}
 *
 * @public
 */
function isNotSupported(obj) {
    return isAnalyticalBackendError(obj) && obj.abeType === exports.AnalyticalBackendErrorTypes.NOT_SUPPORTED;
}
exports.isNotSupported = isNotSupported;
/**
 * Type guard checking whether input is an instance of {@link NotImplemented}
 *
 * @public
 */
function isNotImplemented(obj) {
    return isAnalyticalBackendError(obj) && obj.abeType === exports.AnalyticalBackendErrorTypes.NOT_IMPLEMENTED;
}
exports.isNotImplemented = isNotImplemented;
/**
 * Type guard checking whether input is an instance of {@link NotAuthenticated}
 *
 * @public
 */
function isNotAuthenticated(obj) {
    return isAnalyticalBackendError(obj) && obj.abeType === exports.AnalyticalBackendErrorTypes.NOT_AUTHENTICATED;
}
exports.isNotAuthenticated = isNotAuthenticated;
//# sourceMappingURL=index.js.map